const SLUG_PLACEHOLDERS = ['{userName}', 'my'];
export class PublicRouterService {
  constructor(wixUserAPI, wixWindowAPI, wixLocationAPI) {
    this.wixUserAPI = wixUserAPI;
    this.wixWindowAPI = wixWindowAPI;
    this.wixLocationAPI = wixLocationAPI;
  }
  async getRouteData() {
    const currentMemberIdentifier = this.getCurrentMemberIdentifier();
    const viewedMemberIdentifier = this.getViewedMemberIdentifier() ?? currentMemberIdentifier;
    const routerData = {
      currentMemberIdentifier,
      viewedMemberIdentifier
    };
    return routerData;
  }
  getCurrentMemberIdentifier() {
    return this.wixUserAPI.currentUser.loggedIn ? {
      id: this.wixUserAPI.currentUser.id,
      slug: null
    } : null;
  }
  getViewedMemberIdentifier() {
    const routerPublicData = this.wixWindowAPI.getRouterPublicData();
    const viewedUser = routerPublicData == null ? void 0 : routerPublicData.viewedUser;
    if (viewedUser) {
      return {
        id: viewedUser.id,
        slug: viewedUser.slug
      };
    }
    return this.getViewedMemberFromLocationPath();
  }
  getViewedMemberFromLocationPath() {
    var _this$wixLocationAPI;
    const slugOrId = (_this$wixLocationAPI = this.wixLocationAPI) == null ? void 0 : _this$wixLocationAPI.path[1];
    if (!slugOrId || SLUG_PLACEHOLDERS.includes(slugOrId)) {
      return null;
    }
    return {
      id: slugOrId,
      slug: slugOrId
    };
  }
}
//# sourceMappingURL=public-router.js.map